export default __webpack_public_path__ + "static/media/KASALA.61f23b5c.png";